import { createTheme, MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import type { JSX, ReactNode } from 'react';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { THEME } from '@feathr/components';
import { ActionBarProvider } from '@feathr/extender/state';
import { i18n } from '@feathr/locales';
import { AuthenticatedStoreContext, createAuthenticatedStore } from '@feathr/report_components';

import ScoutBadge from '../components/ScoutBadge';
import { getScoutBasename } from '../utils/scoutSession';

interface IProps {
  children: ReactNode;
}

function AppWrapper({ children }: Readonly<IProps>): JSX.Element {
  const store = createAuthenticatedStore();
  const theme = createTheme(THEME);

  return (
    <I18nextProvider i18n={i18n}>
      <AuthenticatedStoreContext.Provider value={store}>
        <PostHogProvider client={posthog}>
          <BrowserRouter basename={getScoutBasename(PUBLIC_PATH_PREFIX, GIT_VERSION)}>
            <MantineProvider theme={theme}>
              <ModalsProvider>
                <ActionBarProvider>{children}</ActionBarProvider>
                <ScoutBadge />
              </ModalsProvider>
            </MantineProvider>
          </BrowserRouter>
        </PostHogProvider>
      </AuthenticatedStoreContext.Provider>
    </I18nextProvider>
  );
}

export default AppWrapper;
